import BaseClass from "../BaseClass";
import FullscreenGallery from "./FullscreenGallery";

const defaultOptions = {};

/**
 * This class is used for handling galleries.
 */
export default class GalleriesWrapper extends BaseClass {

    constructor(options)
    {
        super(options, defaultOptions);

        window.galleries = {};

        GalleriesWrapper.init(document);
    }

  /**
   * This function initialise the galeries under parent.
   *
   * @param {String} parent
   */
    static init(parent)
    {
        $(parent).ready(() => {
            $(parent).find('[data-fullscreen-gallery]').each((index, element) => {
                let name = $(element).data('fullscreenGallery');
                let gallery = new FullscreenGallery(name);

                window.galleries[name] = gallery;
                gallery.initGallery();
            });
        });
    }
}
